import mapKnownValues from "@/utils/mapKnownValues";
import { AbilityBuilder, Ability } from "@casl/ability";
import { AppAbility } from "@/appAbility";
import makeClassAttrsEnumerable from "@/utils/makeClassAttrsEnumerable";
import Role, { RoleAPIResponse, RoleEnum } from "@/classes/role";

export type UserProfileData = {
  id: string;
  organization: string;
  property: string;
  email: string;
  nameFirst: string;
  nameLast: string;
  address: string;
  rfid: string;
  phone: string;
  role: RoleAPIResponse | null;
  forceResetPassword: boolean;
};

export default class UserProfile {
  id = "";
  organization = "";
  property = "";
  email = "";
  nameFirst = "";
  nameLast = "";
  address = "";
  rfid = "";
  phone = "";
  role: Role | null = null;
  roleDisplay = "";
  forceResetPassword = false;

  constructor(params: Partial<UserProfile> = {}) {
    mapKnownValues(this, params);
    makeClassAttrsEnumerable.bind(this)(UserProfile, ["name", "initials"]);
  }

  get name() {
    return `${this.nameFirst} ${this.nameLast}`;
  }

  get initials() {
    const firstInitial = this.nameFirst.charAt(0).toUpperCase();
    const lastInitial = this.nameLast.charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }

  hasRole(role: RoleEnum) {
    return this.role?.rName === role;
  }

  updateRules() {
    const { can, rules } = new AbilityBuilder<AppAbility>(Ability);
    if (this.hasRole(RoleEnum.Admin)) {
      can("manage", RoleEnum.All);
      can("read", RoleEnum.All);
    } else if (this.hasRole(RoleEnum.AdminReadOnly)) {
      can("read", RoleEnum.All);
    } else if (this.hasRole(RoleEnum.Support)) {
      can("manage", RoleEnum.Support);
    } else if (this.hasRole(RoleEnum.Organization)) {
      can("manage", [RoleEnum.Organization, RoleEnum.Property, RoleEnum.User]);
    } else if (this.hasRole(RoleEnum.Property)) {
      can("manage", [RoleEnum.Property, RoleEnum.User]);
    }
    return rules;
  }
}
